import { render } from "./Videoplay.vue?vue&type=template&id=3811c3fe"
import script from "./Videoplay.vue?vue&type=script&lang=js"
export * from "./Videoplay.vue?vue&type=script&lang=js"

import "./Videoplay.vue?vue&type=style&index=0&id=3811c3fe&lang=scss"

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Experts\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__